var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiImage',_vm._b({staticClass:"preview-image",class:{'--zoom-in':_vm.isActiveZoom},on:{"click":_vm.onImageClick,"mousemove":_vm.onMouseMove,"mouseleave":_vm.deactiveZoom}},'UiImage',Object.assign({}, _vm.image),false))}
var staticRenderFns = []

export { render, staticRenderFns }